import StatusPage from "./StatusPage"

// The :slug* catch-all is handled inside StatusPage via URL parsing.
// For vike + aldoo-ra routes, we export paths the glob picks up.
export default { "/status/:slug*": StatusPage }
